export default __webpack_public_path__ + "assets/a12b6b7f17655b9d9d8d990582c7149e.svg";